import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { duelAttention } from '../duel-attention.js';

export const useDuelAttention = () => {
  const direct = useQuery({
    queryKey: ['duels'],
    queryFn: api.duels,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
  const tournaments = useQuery({
    queryKey: ['duel-tournaments'],
    queryFn: api.duelTournaments,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
  return duelAttention(direct.data, tournaments.data?.mine);
};
